<!--
 * @Descripttion:
 * @Version: 1.0
 * @Author: +C
 * @Date: 2022-02-15 08:47:06
 * @LastEditors: wufz
 * @LastEditTime: 2023-01-12 14:26:17
-->
<script>
export default {
  name: `DxxOption`,
  functional: true, //函数式组件
  props: [],
  //建立虚拟 DOM
  render(createElement, context) {
    //编辑：dom表单元素
    let drawFromComponents = createElement(
      // 标签名称
      `vxe-option`,
      // 传递数据
      {
        ...context.data,
        props: {
          ...context.props
        },
        class: (context.data.staticClass || "") + "", //自定义class
        style: {
          ...context.data.staticStyle
        }
      },
      // 子节点数组，createElement...
      [
        context.slots().default
      ]
    );

    return drawFromComponents;
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/form/selectOption.vue